import React, { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { PageTemplate } from '../../layout/PageTemplate/PageTemplate';
import { useSurveyLaunches } from '../../hooks/useSurveys';
import { useSurveyEditor } from './useSurveyEditor';
import { SurveyRoundStatus } from './SurveyRoundStatus/SurveyRoundStatus';
import { SurveyResultsTab } from './SurveyResults/SurveyResultsTab';
import { SurveyEditorTab } from './SurveyEditor/SurveyEditorTab';
import './Surveys.scss';

const RESULTS_TAB = 0;
const EDITOR_TAB = 1;

export function Surveys(): React.ReactElement {
  const editor = useSurveyEditor();
  const { data: launches } = useSurveyLaunches();
  const [chosenTab, setChosenTab] = useState<number>();

  // Until the employee picks a tab: results when there is any round, else the editor to prepare the first one.
  const defaultTab = launches && launches.length === 0 ? EDITOR_TAB : RESULTS_TAB;
  const activeTab = chosenTab ?? defaultTab;

  return (
    <PageTemplate title='Encuestas' className='surveys-page'>
      <SurveyRoundStatus editor={editor} launches={launches} onOpenEditor={() => setChosenTab(EDITOR_TAB)} />
      <TabView activeIndex={activeTab} onTabChange={(event) => setChosenTab(event.index)} className='surveys-tabs'>
        <TabPanel header='Resultados' leftIcon='pi pi-chart-bar'>
          <SurveyResultsTab launches={launches ?? []} onOpenEditor={() => setChosenTab(EDITOR_TAB)} />
        </TabPanel>
        <TabPanel header={editor.hasChanged ? 'Editar encuesta •' : 'Editar encuesta'} leftIcon='pi pi-pencil'>
          <SurveyEditorTab editor={editor} />
        </TabPanel>
      </TabView>
    </PageTemplate>
  );
}
